import { Loader } from "lucide-react";
import { type StatusConfig, TONE, type Tone } from "@/lib/status";
import { cn } from "@/lib/utils";

/** Compact status indicator. All statuses render through src/lib/status configs. */
export function StatusBadge({ config, className, iconOnly = false }: { config: StatusConfig; className?: string; iconOnly?: boolean }) {
  const t = TONE[config.tone];
  const Icon = config.icon;
  return (
    <span
      title={config.description ?? config.label}
      className={cn(
        "inline-flex h-5 shrink-0 items-center gap-1 whitespace-nowrap rounded px-1.5 font-medium text-[11px] ring-1 ring-inset",
        t.bg,
        t.text,
        t.ring,
        className,
      )}
    >
      <Icon aria-hidden className={cn("size-3", Icon === Loader && "animate-spin")} />
      {iconOnly ? <span className="sr-only">{config.label}</span> : config.label}
    </span>
  );
}

export function StatusDot({ tone, label, className }: { tone: Tone; label?: string; className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      <span aria-hidden className={cn("size-2 shrink-0 rounded-full", TONE[tone].dot)} />
      {label ? <span>{label}</span> : null}
    </span>
  );
}
